import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="accordion"
export default class extends Controller {
  static targets = ["content", "icon"]

  toggle(event) {
    const button = event.currentTarget
    const container = button.closest('div')
    const content = container.querySelector('.faq-content')
    const icon = button.querySelector('svg')

    // Toggle the 'hidden' class on content
    content.classList.toggle("hidden")

    // Rotate icon and update ARIA state
    const isExpanded = !content.classList.contains("hidden")
    button.setAttribute("aria-expanded", isExpanded)
    
    if (isExpanded) {
      icon.classList.add("rotate-180")
    } else {
      icon.classList.remove("rotate-180")
    }
  }
}
